import { resolveAdminAppUrl, resolvePublicWebsiteUrl } from './environment-urls';

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || 'https://api.headstart.health';
export const ADMIN_APP_URL = resolveAdminAppUrl({
  configuredAdminUrl: import.meta.env.VITE_ADMIN_APP_URL,
  legacyConfiguredAppUrl: import.meta.env.VITE_APP_URL,
  isLocalDevelopment: import.meta.env.DEV,
});
export const FRONTEND_APP_URL =
  import.meta.env.VITE_FRONTEND_APP_URL || 'https://app.headstart.health';
export const PUBLIC_WEBSITE_URL = resolvePublicWebsiteUrl({
  configuredPublicWebsiteUrl: import.meta.env.VITE_PUBLIC_WEBSITE_URL,
  isLocalDevelopment: import.meta.env.DEV,
});

export const GOOGLE_OAUTH_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID ||
  '846399596004-77rbpjetg1s4jdoju9v6tbr7ufvno6sp.apps.googleusercontent.com';
export const GOOGLE_OAUTH_REDIRECT_URI = `${ADMIN_APP_URL}/google-redirect`;
